module.exports = __webpack_public_path__ + "static/media/state-govt-logo.9fe5d967.png";